module.exports = __webpack_public_path__ + "img/36600.ab2fdd7c.jpg";